import {ArrayUtils} from './ArrayUtils'

export module RandomUtils {
    export function randomIntBetween(minInclusive: number, maxInclusive: number): number {
        return Math.floor(Math.random() * (maxInclusive - minInclusive + 1)) + minInclusive
    }

    export function randomNumberBetweenFloat(minValue: number, maxValue: number): number {
        return (Math.random() * (maxValue - minValue)) + minValue
    }

    export function randomUniqueIndicesFromLength(length: number, uniqueIndicesNum: number): number[] {
        const numbersSet = new Set<number>()

        if(length === 0) return []

        const tooManyIndicesRequested = uniqueIndicesNum > length
        if(tooManyIndicesRequested) uniqueIndicesNum = length

        for(let i = 0; i < uniqueIndicesNum; i += 1) {
            const randomIndex = randomIntBetween(0, length - 1)
            if(numbersSet.has(randomIndex)) {
                i -= 1
                continue
            }
            numbersSet.add(randomIndex)
        }
        return Array.from(numbersSet)
    }

    const allPossibleCharacters = [
        'A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I',
        'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R',
        'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z', 'a',
        'b', 'c', 'd', 'e', 'f', 'g', 'h', 'i', 'j',
        'k', 'l', 'm', 'n', 'o', 'p', 'q', 'r', 's',
        't', 'u', 'v', 'w', 'x', 'y', 'z', '0', '1',
        '2', '3', '4', '5', '6', '7', '8', '9',
    ]
    const ambiguousCharacters = [
        '1', 'I', 'l',
        'O', '0',
    ]
    const possibleCharacters = ArrayUtils.differenceOfTwoArrays(allPossibleCharacters, ambiguousCharacters)

    export function randomStringId(length: number): string {
        let text = ''
        for(let i = 0; i < length; i += 1) {
            text += possibleCharacters[Math.floor(Math.random() * possibleCharacters.length)]
        }
        return text
    }

    export function randomNumberExcept(minInclusive: number, maxInclusive: number, except: number): number {
        const randomNo = randomIntBetween(minInclusive, maxInclusive)
        if(randomNo != except) {
            return randomNo
        }
        return randomNumberExcept(minInclusive, maxInclusive, except)
    }

    export function randomBool(): boolean {
        return Math.random() >= 0.5
    }

    export function randomAngle(): number {
        return Math.PI * 2 * Math.random()
    }

    export function randomSign(): -1 | 1 {
        return Math.random() < 0.5 ? -1 : 1
    }

    export function randomNegativePositive(n: number): number {
        return n * Math.random() * randomSign()
    }

    // Source: github copilot
    export function randomWeightedValue<T>(values: T[], weights: number[]): T {
        const totalWeight = weights.reduce((a, b) => a + b, 0)
        const randomWeight = Math.random() * totalWeight
        let weightSum = 0
        for(let index = 0; index < values.length; index += 1) {
            weightSum += weights[index]
            if(randomWeight <= weightSum) {
                return values[index]
            }
        }
        const lastElementAsFallback = values[values.length - 1]
        return lastElementAsFallback
    }
}
